import BaseView, { DomainModel3D } from './base-view';
import CubbyView from './cubby-view';
import DoorView from './door-view';
import DrawerView from './drawer-view';
import GenericAssetView from './generic-asset-view';
import ParametricPartView from './parametric-part-view';
import SlantedShelfView from './slanted-shelf-view';
import logging from '../logging';
import { Mesh, MeshBasicMaterial, PlaneGeometry } from 'three';
import { Section } from '../domain';
import { gammaCorrect } from '../utils/gamma-correct';

const log = logging('view');

const unitPlane = new PlaneGeometry(1, 1);
    // new BoxGeometry(1, 1, 1);
unitPlane.translate(0.5, 0.5, 0);

// Used on planes that provide hit detection for sections.
const hitMaterial = new MeshBasicMaterial({
    color: gammaCorrect(0x14a79d),
});

export default class SectionView extends BaseView {

    declare model: Section;

    sections: SectionView[];

    hit: Mesh;

    constructor(model: DomainModel3D) {
        super(model);
        this.onReady.name = 'SectionView';
        // Instead of running init() like most views, we run make and bind
        // individually to avoid running bindTransform(), which is called in
        // the BaseView's init() implementation.
        this.make();
        this.bind();
    }

    make() {
        this.name = 'Section';

        this.sections = [];

        this.hit = new Mesh(unitPlane, hitMaterial);
        this.hit.visible = false;
        this.add(this.hit);

        this.hit.name = 'Section Hit';
        this.hit.userData.isSelectable = true;
        this.hit.userData.isSectionHit = true;

        this.highlights.add(this.hit);

        this.userData.isParametric = true;
        this.name = 'Section';

        for(const asset of this.model.assets) {
            let view = new GenericAssetView(asset);
            this.add(view);
        }
        for(const part of this.model.parametricParts) {
            let view = new ParametricPartView(part);
            this.add(view);
        }
        for(const door of this.model.doors) {
            this.add(new DoorView(door));
        }
        for(const cubby of this.model.cubbies) {
            this.add(new CubbyView(cubby));
        }
        for(let drawer of this.model.drawers) {
            this.add(new DrawerView(drawer));
        }
        for(let shelf of this.model.slantedShelves) {
            this.add(new SlantedShelfView(shelf));
        }


        this.onReady.trigger();
    }

    bind() {
        this.model.position.bind(
            'x', () => this.position.x = this.model.position.x);
        this.model.bind('width', this.changeSize);
        this.model.on('height', this.changeSize);
        this.model.on('depth', this.changeSize);
    }

    private changeSize = () => {
        this.hit.scale.set(this.model.width, this.model.height, 1);
        this.hit.position.y = this.model.position.y;
    }
}
